import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { delay } from 'lodash';
import shortid from 'shortid';
import ProgessBar from '../progress-bar';

class CheckConnection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: shortid.generate(),
      connected: null,
    };
    this.checkConnection = this.checkConnection.bind(this);
    this.handler = this.handler.bind(this);
    delay(() => {
      this.checkConnection();
    }, 100);
  }

  handler(params) {
    const { socket } = this.context;
    if (params.id === this.state.id) {
      if (params.timeout) {
        this.setState({ connected: false }, () => {
          this.props.onNotConnected();
        }); // timeout
      } else {
        this.setState({ connected: true }, () => {
          this.props.onConnected();
        });
      }
      clearTimeout(this.timeoutId); // turn off event
      socket.off('ts-pong', this.handler); // turn off event
    }
  }

  checkConnection() {
    const { socket } = this.context;
    const params = { id: this.state.id };
    socket.on('ts-pong', this.handler);
    // time out, incase no respone
    this.timeoutId = setTimeout(this.handler, 2000, { ...params, timeout: true });
    socket.emit('ts-ping', params);
  }

  render() {
    const { connected } = this.state;
    if (connected === null) {
      return (
        <ProgessBar />
      );
    } else if (connected === false) {
      return (
        <div className="alert alert-danger">Socket not connected. Please refresh the page and try again.</div>
      );
    }
    return this.props.children;
  }
}

CheckConnection.propTypes = {
  children: PropTypes.node,
  onConnected: PropTypes.func,
  onNotConnected: PropTypes.func,
};

CheckConnection.defaultProps = {
  children: null,
  onConnected: () => {},
  onNotConnected: () => {},
};
CheckConnection.contextTypes = {
  socket: PropTypes.shape({}).isRequired,
};

export default CheckConnection;
